module.exports = __webpack_public_path__ + "static/media/cap.505ec885.jpg";